/* ==========================================================================

 LoaderView

 Author:      Dave Taylor (http://davetayls.me)
 Description: Backbone view for Loader spinner

 ========================================================================== */
'use strict';

import {View} from 'backbone';

class LoaderView extends View {

  get className() {
    return 'Loader';
  }

  render() {
    this.$el.html('<span></span>');
    return this;
  }
}

module.exports = LoaderView;



// WEBPACK FOOTER //
// ./assets/components/Loader/LoaderView.js